<template>
  <a-card>
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item :label="$t('应用')">
              <a-select v-model="queryParams.appId" :options="appOptions" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="handleRefresh(true)">{{ $t('查询') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleReview(record)">{{ $t('查看') }}</a>    
      </div>
    </a-table>
  </a-card>
</template>
<script>
import { getNoticeList } from '@/api/system/notice'
import { getAppListForCurrentUser } from '@/api/app/app'
import { getLabelFromOptions } from '@/utils/dictUtils'

export default {
  data() {
    return {
      queryParams: {},
      appOptions: [],
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('序号'),
          width: 80,
          dataIndex: 'index',
          customRender: (text, record, index) => {
            return index + 1
          }
        },
        {
          title: this.$t('应用'),
          dataIndex: 'appId',
          customRender: (text) => {
            return getLabelFromOptions(text, this.appOptions, text)
          }
        },
        {
          title: this.$t('消息内容'),
          dataIndex: 'content',
        },
        {
          title: this.$t('创建时间'),
          width: 200,
          dataIndex: 'createTime',
        },
      ]
    }
  },
  mounted() {
    this.handleRefresh()
    this.loadOptions()
  },
  methods: {
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getNoticeList({ ...params }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
    },
    handleReview(record) {
      this.$refs.log.show(record)
    },
  }
}
</script>